import { Component, Input, Output, EventEmitter } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-user-profile-about",
  templateUrl: "./user-profile-about.component.html",
  styleUrls: ["./user-profile-about.component.scss"],
})
export class UserProfileAboutComponent {
  @Input() userDetails: any = {};
  @Input() statsDetails: any[] = [];
  @Input() socialLinks: { type: string; url: string }[] = [];
  @Input() mileStone: number[] = [];

  @Output() statsCardClick = new EventEmitter<any>();

  environment = environment;

  onStatsCardClick(stat: any) {
    this.statsCardClick.emit(stat);
  }
}
